import { useQuery } from "@tanstack/react-query";

import input from "../../../../assets/styles/components/input.module.css";
import { getChartOfAccounts } from "../../../../services/cashFlow";

interface SelectChartOfAccountsProps {
  handleChangeChartOfAccount: (e: string) => void;
  value: string | null;
  type: "receita" | "despesa" | "ambos";
  disabled?: boolean;
}

const SelectChartOfAccounts = ({
  handleChangeChartOfAccount,
  value,
  type,
  disabled,
}: SelectChartOfAccountsProps) => {
  const { data } = useQuery({
    queryKey: ["getChartOfAccounts"],
    queryFn: () => getChartOfAccounts(type),
  });

  const handleChange = (e: string) => {
    handleChangeChartOfAccount(e);
  };

  return (
    <label>
      Plano de Contas
      <select
        className={input.input}
        value={value ?? ""}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        data-readonly={disabled}
      >
        <option defaultValue="">{!disabled ? "Selecione" : "-"}</option>
        {data &&
          Object.values(data).length > 0 &&
          data.map(
            (c: {
              uid_plano_contas: string;
              nome: string;
              codigo_classificacao: string;
            }) => (
              <option value={c.uid_plano_contas} key={c.uid_plano_contas}>
                {c.codigo_classificacao} - {c.nome}
              </option>
            ),
          )}
      </select>
    </label>
  );
};

export default SelectChartOfAccounts;
